import React from 'react';
import LettingHubCardBase from '../LettingHubCardBase';
const BACKGROUND_IMAGE_MOBILE = 'https://www.haven.com/assets/images/draindown-card-mobile.jpeg';
const BACKGROUND_IMAGE_DESKTOP = 'https://www.haven.com/assets/images/draindown-card-desktop.jpeg';
export const DraindownCard = ({ onClick, variant }) => {
    return (<LettingHubCardBase variant={variant} title='Book a draindown' description='Get winter ready by booking a draindown today' backgroundImageMobile={BACKGROUND_IMAGE_MOBILE} backgroundImageDesktop={BACKGROUND_IMAGE_DESKTOP} onClick={onClick}/>);
};
